import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { PUT } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  UPDATE_MOTORBIKE,
  UPDATE_MOTORBIKE_FAILURE,
  UPDATE_MOTORBIKE_SUCCESS,
  UpdateMotorbikeActionType,
  FETCH_MOTORBIKES
} from 'src/redux/motorbikesReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* UpdateMotorbikeFlow(action: UpdateMotorbikeActionType): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = `/dealers_api/motorbikes/${action.payload.id}`
    yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: PUT,
      params: {
        motorbike: action.payload
      }
    })
    yield put(UPDATE_MOTORBIKE_SUCCESS())
    yield put(FETCH_MOTORBIKES())
  } catch (error) {
    yield put(UPDATE_MOTORBIKE_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* UpdateMotorbikeSaga(): Generator<any, void, any> {
  yield takeLatest(UPDATE_MOTORBIKE, UpdateMotorbikeFlow)
}
